module.exports = __webpack_public_path__ + "media/images/google-icon-color-9dd028e98fc313d8c7f69b38e2ff2d6f.png";